import { Component, OnInit, ViewChild } from "@angular/core";
import { DataService } from '../../shared/dataService';
import { JobOffer } from '../../shared/joboffer';
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import '@ckeditor/ckeditor5-build-classic/build/translations/nl';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastrService } from 'ngx-toastr';
import { isNgTemplate } from '@angular/compiler';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
    selector: "job-offer-page",
    templateUrl: "jobofferpage.component.html",
    styleUrls: []
})

export class JobOfferPage implements OnInit {
    constructor(private data: DataService, private route: ActivatedRoute, private formBuilder: FormBuilder, private toastr: ToastrService, private confirmationDialogService: ConfirmationDialogService, private router: Router) {
    }
    public Editor = ClassicEditor;
    public jobOffer: JobOffer = null;
    public loading: boolean = true;
    pageForm: FormGroup;
    submitted = false;

    ngOnInit(): void {
        this.pageForm = this.formBuilder.group({
            id: ['', []],
            title: ['', Validators.required],
            urlString: ['', Validators.required],
            shortDescription: ['', Validators.required],
            description: ['', [Validators.required]],
            inActive: ['', []]
        });
        this.loading = true;
        if (this.route.snapshot.paramMap.get("id") !== "0")
            this.data.loadJobOffer(this.route.snapshot.paramMap.get("id")).subscribe(success => {
                if (success) {
                    this.jobOffer = this.data.jobOffer;
                    this.pageForm.patchValue(this.jobOffer);
                } else {
                    this.jobOffer = null;
                    this.pageForm.patchValue({});
                }
                this.loading = false;
            });
        else {
            this.jobOffer = {
                id: 0,
                description: "",
                inActive: false,
                title: "",
                activeFrom: null,
                activeTo: null
            };
            this.pageForm.patchValue(this.jobOffer);

            this.loading = false;
        }
    }

    get f() { return this.pageForm.controls; }

    onSubmit() {
        this.loading = true;
        this.submitted = true;
        // stop here if form is invalid
        if (this.pageForm.invalid) {
            this.loading = false;
            this.toastr.warning('Verbeter de gegevens in het formulier.');
            return;
        }
        this.loading = true;
        this.data.saveJobOffer(this.pageForm.value).subscribe((result) => {
            if (result.success) {
                if (this.route.snapshot.paramMap.get("id") === "0")
                    this.router.navigate(['vacatures', this.data.jobOffer.id]);
                this.jobOffer = this.data.jobOffer;
                this.pageForm.patchValue(this.jobOffer);
                this.toastr.success(result.message);
            } else {
                this.toastr.error(result.message);
            }

            this.loading = false;
        });
    }

    onRemoveItem() {
        this.confirmationDialogService.confirm('Bevestig verwijdering', 'Weet u zeker dat u deze vacature wilt verwijderen?', 'Ja', 'Nee', 'lg')
            .then((confirmed) => {
                if (confirmed) {
                    this.loading = true;
                    this.data.deleteJobOffer(this.route.snapshot.paramMap.get("id")).subscribe(result => {
                        if (result.success) {
                            this.toastr.success(result.message);
                            this.router.navigate(['vacatures']);
                        } else {
                            this.toastr.error(result.message);
                        }
                        this.loading = false;
                    });
                    //this.data.saveJobOffer(this.pageForm.value).subscribe((success) => {
                    //    if (success) {
                    //        this.jobOffer = this.data.jobOffer;
                    //        this.pageForm.patchValue(this.jobOffer);
                    //        this.toastr.success('Het item is succesvol opgeslagen.');
                    //    } else {
                    //        this.toastr.error('Het item kon niet worden opgeslagen.');
                    //    }
                    //});
                }
            });
    }
}